module.exports = __webpack_public_path__ + "img/secure_pwd.575725f0.svg";